var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"md-3"},[_c('b-card-text',{staticClass:"userTable"},[_c('div',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"search-options":{
                    enabled: true,
                    //trigger: 'enter',
                    skipDiacritics: true,
                    //searchFn: mySearchFn,
                    placeholder: 'Buscar en la tabla',
                    //externalQuery: searchQuery
                   },"pagination-options":{
                       enabled: true,
                       mode: 'records',
                       perPage: 10,
                       dropdownAllowAll: false,
                       //setCurrentPage: 2,
                       nextLabel: '',
                       prevLabel: '',
                       rowsPerPageLabel: 'Filas por pagina',
                       ofLabel: 'de',
                       pageLabel: 'pagina', // for 'pages' mode
                       allLabel: 'Todas',
                     }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'acciones')?_c('span',[_c('a',{staticStyle:{"color":"#606266 !important"},attrs:{"href":"#content"}},[_c('span',{staticStyle:{"margin-right":"10px"},on:{"click":function($event){return _vm.editRow(props.row.id)}}},[_c('i',{staticClass:"far fa-edit fa-lg",staticStyle:{"cursor":"pointer"}})])]),_c('span',{on:{"click":function($event){return _vm.deleteModalPopup(props.row.id)}}},[_c('i',{staticClass:"far fa-trash-alt fa-lg",staticStyle:{"cursor":"pointer"}})])]):_vm._e()]}}])})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }